import React, { useContext, useState } from 'react'

import { Button, Dropdown, Popup } from 'semantic-ui-react'

import { UserContext } from '../../contexts/UserContext'
import { getFontFileFromFontCSS } from '../../utils/sharedFunctions'

import {
  getNewRatingElement,
  getNewTextElement,
  getNewImageElement,
  getNewLogoElement,
} from '../../components/common/ThemeElement'
import { ReactComponent as WatermarkIcon } from '../../_images/designer-add-watermark.svg'
import { ReactComponent as DynamicTextIcon } from '../../_images/designer-add-dynamic-text.svg'

import DesignerImageSelectModal from './modals/DesignerImageSelectModal'
import DesignerIntroOutroSelectionModal from './modals/DesignerIntroOutroSelectionModal'
import DesignerStaticTextPromptModal from './modals/DesignerStaticTextPromptModal'
import DesignerDynamicTextPromptModal from './modals/DesignerDynamicTextPromptModal'

export const getStoredWatermarkSource = ({ watermarkId, logoWatermarkUrl }) => {
  if (watermarkId) return watermarkId

  const watermarkUrlMatch = logoWatermarkUrl?.match(/\/themes\/assets\/([^/?#]+)/)
  return watermarkUrlMatch?.[1] || 'default-logo-watermark'
}

const DropDownOpeningAndClosingElements = ({
  sectionName,
  setIntroOutroSelectModal,
  setImageSelectionModal,
  setShowStaticTextPromptModal,
  addLogoElement,
  setShowDynamicTextPromptModal,
  setDynamicTextSection,
}) => {
  return (
    <Dropdown
      className="primary icon"
      button
      icon="add"
      pointing="left"
      upward={false}
      style={{ marginRight: '0', marginBottom: '1rem' }}
    >
      <Dropdown.Menu>
        <Dropdown.Header>Change {sectionName} video</Dropdown.Header>
        <Dropdown.Item icon="film" text="Video" onClick={() => setIntroOutroSelectModal(true)} />
        <Dropdown.Divider />

        <Dropdown.Item
          content={
            <>
              <WatermarkIcon style={{ width: '1rem', height: '1rem', marginRight: '1rem', verticalAlign: 'middle' }} />
              Watermark
            </>
          }
          value="logo"
          key="logo"
          onClick={addLogoElement}
        />
        <Dropdown.Item
          icon="font"
          text="Static Text"
          value="static"
          onClick={() => setShowStaticTextPromptModal(true)}
        />
        <Dropdown.Item
          content={
            <>
              <DynamicTextIcon
                style={{ width: '1rem', height: '1rem', marginRight: '1rem', verticalAlign: 'middle' }}
              />
              Dynamic Text
            </>
          }
          value="dynamic"
          onClick={() => {
            setDynamicTextSection(sectionName)
            setShowDynamicTextPromptModal(true)
          }}
        />
        <Dropdown.Item icon="object group outline" text="Image" onClick={() => setImageSelectionModal(true)} />
      </Dropdown.Menu>
    </Dropdown>
  )
}

const DropDownVloggiElements = ({
  sectionName,
  setImageSelectionModal,
  addLogoElement,
  addRatingElement,
  setShowStaticTextPromptModal,
  setShowDynamicTextPromptModal,
  setDynamicTextSection,
}) => {
  return (
    <Dropdown
      className="primary icon"
      button
      icon="add"
      pointing="left"
      upward={false}
      style={{ marginRight: '0', marginBottom: '1rem' }}
    >
      <Dropdown.Menu>
        <Dropdown.Item
          content={
            <>
              <WatermarkIcon style={{ width: '1rem', height: '1rem', marginRight: '1rem', verticalAlign: 'middle' }} />
              Watermark
            </>
          }
          value="logo"
          key="logo"
          onClick={addLogoElement}
        />
        <Dropdown.Item
          icon="font"
          text="Static Text"
          value="static"
          onClick={() => setShowStaticTextPromptModal(true)}
        />
        <Dropdown.Item
          content={
            <>
              <DynamicTextIcon
                style={{ width: '1rem', height: '1rem', marginRight: '1rem', verticalAlign: 'middle' }}
              />
              Dynamic Text
            </>
          }
          value="dynamic"
          onClick={() => {
            setDynamicTextSection(sectionName)
            setShowDynamicTextPromptModal(true)
          }}
        />
        <Dropdown.Item icon="object group outline" text="Image" onClick={() => setImageSelectionModal(true)} />
        <Dropdown.Item key="rating" value="rating" onClick={addRatingElement} icon="star" text="Rating" />
      </Dropdown.Menu>
    </Dropdown>
  )
}

const DesignerTabSectionAddItem = (props) => {
  const { userProfile } = useContext(UserContext)

  // Props
  const {
    section,
    sectionName,
    selectedIndex,
    setSelectedIndex,
    defaultFonts,
    themeHistory,
    copiedElement,
    projectData,
  } = props
  const { updateThemeSection, revertChange, copyThemeElement, pasteThemeElement } = props

  // States
  const [introOutroSelectModal, setIntroOutroSelectModal] = useState(false)
  const [imageSelectionModal, setImageSelectionModal] = useState(false)
  const [showStaticTextPromptModal, setShowStaticTextPromptModal] = useState(false)
  const [showDynamicTextPromptModal, setShowDynamicTextPromptModal] = useState(false)
  const [dynamicTextSection, setDynamicTextSection] = useState(null)

  // Add element
  const addThemeElement = (e, { value }, text = null) => {
    setShowStaticTextPromptModal(false)
    setShowDynamicTextPromptModal(false)

    const defaultFontFamily = defaultFonts[0]
    const fontfile = getFontFileFromFontCSS(defaultFontFamily, 'normal', 'normal')
    const newElement = getNewTextElement(value, fontfile, text)

    const newThemeSection = { ...section }

    newThemeSection.elements.push(newElement)

    updateThemeSection(newThemeSection)

    const indexNewElement = newThemeSection.elements.length - 1
    setSelectedIndex(indexNewElement)
  }

  // Delete an element from the theme
  const deleteThemeElement = () => {
    const newThemeSection = { ...section }

    newThemeSection.elements.splice(selectedIndex, 1)

    setSelectedIndex(null)
    updateThemeSection(newThemeSection)
  }

  // Add Logo element
  const addLogoElement = () => {
    setShowStaticTextPromptModal(false)
    setShowDynamicTextPromptModal(false)

    const watermarkSource = getStoredWatermarkSource(userProfile)

    const newElement = getNewLogoElement(watermarkSource)

    const newThemeSection = { ...section }
    newThemeSection.elements.push(newElement)

    updateThemeSection(newThemeSection)

    const indexNewElement = newThemeSection.elements.length - 1

    setSelectedIndex(indexNewElement)
  }

  // Add rating element
  const addRatingElement = () => {
    setShowStaticTextPromptModal(false)
    setShowDynamicTextPromptModal(false)

    const newElement = getNewRatingElement()

    const newThemeSection = { ...section }
    newThemeSection.elements.push(newElement)

    updateThemeSection(newThemeSection)

    const indexNewElement = newThemeSection.elements.length - 1

    setSelectedIndex(indexNewElement)
  }

  // Change intro outro
  const handleSelectIntroOutro = (itemSelected) => {
    const newThemeSection = { ...section }
    newThemeSection.input = itemSelected

    updateThemeSection(newThemeSection)
    setIntroOutroSelectModal(false)
  }

  // Add image
  const handleSelectImage = (imageSelected) => {
    const { id: src, width, height } = imageSelected
    const newImageElement = getNewImageElement(src, width, height)

    const newThemeSection = { ...section }
    newThemeSection.elements.push(newImageElement)

    updateThemeSection(newThemeSection)
    setImageSelectionModal(false)
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      {['opening', 'closing'].includes(sectionName) && (
        <DropDownOpeningAndClosingElements
          sectionName={sectionName}
          setIntroOutroSelectModal={setIntroOutroSelectModal}
          setImageSelectionModal={setImageSelectionModal}
          setShowStaticTextPromptModal={setShowStaticTextPromptModal}
          setShowDynamicTextPromptModal={setShowDynamicTextPromptModal}
          addLogoElement={addLogoElement}
          setDynamicTextSection={setDynamicTextSection}
        />
      )}

      {['vloggi'].includes(sectionName) && (
        <DropDownVloggiElements
          sectionName={sectionName}
          setIntroOutroSelectModal={setIntroOutroSelectModal}
          setImageSelectionModal={setImageSelectionModal}
          setShowStaticTextPromptModal={setShowStaticTextPromptModal}
          setShowDynamicTextPromptModal={setShowDynamicTextPromptModal}
          addLogoElement={addLogoElement}
          addRatingElement={addRatingElement}
          setDynamicTextSection={setDynamicTextSection}
        />
      )}

      <Popup
        trigger={
          <Button
            style={{ margin: '1rem 0' }}
            inverted
            secondary
            icon="undo"
            disabled={!themeHistory.length}
            onClick={revertChange}
          />
        }
        content="Undo change"
        position="top left"
      />

      <Popup
        trigger={
          <Button
            style={{ margin: '1rem 0' }}
            inverted
            secondary
            icon="copy"
            disabled={selectedIndex === null}
            onClick={() => copyThemeElement(selectedIndex)}
          />
        }
        content="Copy element"
        position="top left"
      />

      <Popup
        trigger={
          <Button
            style={{ margin: '1rem 0' }}
            inverted
            secondary
            icon="clipboard"
            disabled={!copiedElement}
            onClick={() => pasteThemeElement(selectedIndex)}
          />
        }
        content="Paste element"
        position="top left"
      />
      {/* </Grid.Row> */}

      <Popup
        trigger={
          <Button
            style={{ margin: '1rem 0' }}
            inverted
            color="red"
            icon="trash"
            disabled={selectedIndex === null}
            onClick={() => deleteThemeElement(selectedIndex)}
          />
        }
        content="Delete element"
        position="top left"
      />
      {introOutroSelectModal && (
        <DesignerIntroOutroSelectionModal
          section={section}
          sectionName={sectionName}
          updateThemeSection={updateThemeSection}
          handleSelect={handleSelectIntroOutro}
          setShowModal={setIntroOutroSelectModal}
        />
      )}
      {imageSelectionModal && (
        <DesignerImageSelectModal
          updateThemeSection={updateThemeSection}
          handleSelect={handleSelectImage}
          setShowModal={setImageSelectionModal}
        />
      )}

      {showStaticTextPromptModal && (
        <DesignerStaticTextPromptModal handleSubmit={addThemeElement} setShowModal={setShowStaticTextPromptModal} />
      )}

      {showDynamicTextPromptModal && (
        <DesignerDynamicTextPromptModal
          handleSubmit={addThemeElement}
          setShowModal={setShowDynamicTextPromptModal}
          projectData={projectData}
          sectionType={dynamicTextSection}
        />
      )}
    </div>
  )
}

export default DesignerTabSectionAddItem
